import { api } from "./users";

export const getAgents = async (params = {}) => {
  const response = await api.get("/agents/", { params });
  return response.data;
};

export const getAgentReconciliation = async (agentId, { year, month }) => {
  const response = await api.get(`/agents/${agentId}/reconciliation/`, {
    params: { year, month },
  });
  return response.data;
};

export const downloadAgentReconciliationExcel = async (agentId, { year, month }) => {
  const response = await api.get(`/agents/${agentId}/reconciliation/export/`, {
    params: { year, month },
    responseType: "blob",
  });
  return response;
};

export const getCarriers = async (params = {}) => {
  const response = await api.get("/carriers/", { params });
  return response.data;
};

export const getCarrierReconciliation = async (carrierId, { year, month }) => {
  const response = await api.get(`/carriers/${carrierId}/reconciliation/`, {
    params: { year, month },
  });
  return response.data;
};

export const downloadCarrierReconciliationExcel = async (
  carrierId,
  { year, month }
) => {
  const response = await api.get(`/carriers/${carrierId}/reconciliation/export/`, {
    params: { year, month },
    responseType: "blob",
  });
  return response;
};
